import config from "../../src/common/default_config";

export default class options extends config {
  static page_ratio = 1.4925;
  static page_width_reference = 100000;
  static page_height_reference = 100000;
  static editor = "Frankenpost Verlag GmbH";
  static subscriptionOptions = {
    subscriptionType: "subscription",
    subscriptionProvider: "TWIPE-DEMO",
  };

  static replicaReadingModeToggle = { phone: false, tablet: true };
  // default pdf rendering settings
  static usePdfDesktop = true;
  static usePdfPhoneNot = [
    ["Safari", "iOS", "version_8"],
    ["Safari", "iOS", "version_7"],
  ];
  static usePdfPhone = true;
  static usePdfTabletNot = [
    ["Safari", "iOS", "version_8"],
    ["Safari", "iOS", "version_7"],
  ];
  static usePdfTablet = true;

  static useSliderForPromospot = true;
  static useSliderForHorsSeries = true;
  static useSliderForArchive = true;
  static extraLinkDirectAccess = true;

  static dateFormat = "Do MMMM YYYY";

  // Social sharing
  static shareFromReader = true;
  static sharingEnabled = true;
  static sharingOptions = {
    Facebook: true,
    WhatsApp: true,
    TwitterX: true,
    Mail: true,
    MailSubject: null,
    MailSubjectIntro: "",
  };
  static socialSharingHash = "social";

  // Puzzle link in top navigation bar
  static topNavButtonLabel = "Suche";
  static toggleSubscriptionTopNavButtonOnUserLoggedIn = false;

  static replicaReadingModeToggle = {
    phone: false,
    tablet: true,
    desktop: true,
  };
  static replicaReadingModeDefault = {
    phone: false,
    tablet: false,
    desktop: false,
  };
  static useSliderForPromospot = true;
  static useSliderForHorsSeries = true;
  static useSliderForArchive = true;

  static openPrivacyOnNewtab = true;

  static pdfDownloadButtonsConfig = {
    ...config.pdfDownloadButtonsConfig,
    touchDownloadPdf: true,
  };

  static showPrivacyPolicy = true;
  static enableCookieConsent = true;
  static voucher = {
    ...config.voucher,
    isEnabled: true,
    dateFormat: "DD/MM/YYYY",
  };
}



// WEBPACK FOOTER //
// ./clients/SWMH-FP/config.js